module.exports = ".study-footer {\n  color: white;\n  background-color: #6a3171;\n  background-image: url(\"/assets/images/flower-gray-full-slice.png\"); }\n  @media (max-width: 767px) {\n    .study-footer {\n      background-image: url(\"/assets/images/flower-gray-mobile-slice.png\"); } }\n  @media (min-width: 768px) {\n    .study-footer {\n      border-radius: 0 0 5px 5px; } }\n  .study-footer .contact-partner-button {\n    white-space: normal; }\n  .study-footer .da-email-section {\n    margin-bottom: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/partials/study-footer/study-footer.scss
// module id = ./src/app/partials/study-footer/study-footer.scss
// module chunks = main